module.exports = __webpack_public_path__ + "static/media/laptop.996a9f95.png";